import { render, staticRenderFns } from "./security_pending_contracts.vue?vue&type=template&id=55d6360a&scoped=true"
import script from "./security_pending_contracts.vue?vue&type=script&lang=js"
export * from "./security_pending_contracts.vue?vue&type=script&lang=js"
import style0 from "./security_pending_contracts.vue?vue&type=style&index=0&id=55d6360a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6360a",
  null
  
)

export default component.exports